<template>
  <question-renderer :question="src" :indicator="indicator"></question-renderer>
</template>

<script>
import QuestionRenderer from "@/components/QuestionRenderer.vue";
export default {
  name: "ArticleExam",
  props: ["src", "indicator"],
  data: () => ({
    answer: null,
  }),
  components: {
    QuestionRenderer,
  },
  methods: {
    getAnswer() {
      return this.answer;
    },
  },
};
</script>